package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.QuizW500Rounded: ImageVector
    get() {
        if (_quizW500Rounded != null) {
            return _quizW500Rounded!!
        }
        _quizW500Rounded = Builder(name = "QuizW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(595.72f, 577.93f)
                quadToRelative(12.5f, -12.5f, 12.5f, -29.5f)
                reflectiveQuadToRelative(-12.5f, -29.5f)
                quadToRelative(-12.5f, -12.5f, -29.5f, -12.5f)
                reflectiveQuadToRelative(-29.5f, 12.5f)
                quadToRelative(-12.5f, 12.5f, -12.5f, 29.5f)
                reflectiveQuadToRelative(12.5f, 29.5f)
                quadToRelative(12.5f, 12.5f, 29.5f, 12.5f)
                reflectiveQuadToRelative(29.5f, -12.5f)
                close()
                moveTo(566.22f, 466.5f)
                quadToRelative(11.0f, 0.0f, 20.5f, -7.88f)
                reflectiveQuadToRelative(12.21f, -20.88f)
                quadToRelative(2.48f, -11.28f, 8.98f, -21.04f)
                quadToRelative(6.5f, -9.77f, 21.59f, -24.85f)
                quadToRelative(29.76f, -29.76f, 39.88f, -48.5f)
                quadToRelative(10.12f, -18.74f, 10.12f, -43.26f)
                quadToRelative(0.0f, -45.48f, -31.38f, -73.74f)
                quadToRelative(-31.38f, -28.26f, -82.67f, -28.26f)
                quadToRelative(-33.19f, 0.0f, -60.07f, 15.0f)
                quadToRelative(-26.88f, 15.0f, -42.88f, 42.76f)
                quadToRelative(-5.76f, 10.0f, -0.88f, 21.0f)
                reflectiveQuadToRelative(16.88f, 16.0f)
                quadToRelative(11.0f, 5.0f, 21.5f, 1.0f)
                reflectiveQuadToRelative(17.5f, -14.0f)
                quadToRelative(9.0f, -13.0f, 21.12f, -19.38f)
                quadToRelative(12.12f, -6.38f, 26.88f, -6.38f)
                quadToRelative(24.24f, 0.0f, 39.12f, 13.38f)
                quadToRelative(14.88f, 13.38f, 14.88f, 35.9f)
                quadToRelative(0.0f, 14.11f, -8.0f, 26.72f)
                quadToRelative(-8.0f, 12.6f, -28.0f, 31.76f)
                quadToRelative(-27.09f, 23.56f, -35.45f, 37.3f)
                quadToRelative(-8.35f, 13.74f, -10.59f, 37.59f)
                quadToRelative(-1.24f, 11.76f, 7.26f, 20.76f)
                quadToRelative(8.5f, 9.0f, 21.5f, 9.0f)
                close()
                moveTo(328.37f, 722.63f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                verticalLineToRelative(-474.26f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                horizontalLineToRelative(474.26f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                reflectiveQuadToRelative(26.61f, 64.39f)
                verticalLineToRelative(474.26f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(328.37f, 722.63f)
                close()
                moveTo(328.37f, 631.63f)
                horizontalLineToRelative(474.26f)
                verticalLineToRelative(-474.26f)
                lineTo(328.37f, 157.37f)
                verticalLineToRelative(474.26f)
                close()
                moveTo(157.37f, 893.63f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                verticalLineToRelative(-519.76f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                reflectiveQuadToRelative(32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                verticalLineToRelative(519.76f)
                horizontalLineToRelative(519.76f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(157.37f, 893.63f)
                close()
                moveTo(328.37f, 157.37f)
                verticalLineToRelative(474.26f)
                verticalLineToRelative(-474.26f)
                close()
            }
        }
        .build()
        return _quizW500Rounded!!
    }

private var _quizW500Rounded: ImageVector? = null
